import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App"; 
import ThemeHotSwapProvider from "./theme/ThemeHotSwapProvider";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <ThemeHotSwapProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeHotSwapProvider>
  </React.StrictMode>
);
